import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class CreateGift {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * CreateGift constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle creating and storing the gift via the API.
     *
     * @param {*} payload
     *
     * @returns {Promise<any>}
     */
    handle(payload) {
        let apiUrl = ApiEndpoints['gifting.store'];

        return this.apiService.post(apiUrl, payload);
    }
}
